module.exports = __webpack_public_path__ + "static/bootcamp-8f31a5ce01e1073577582bafbc6d3002.jpg";